Element.prototype.extendDOM = function () {

    //#region Container Elements

    this.addH1 = function (text, className, id) {
        var element = document.createElement('h1');
        if (text != null) element.innerText = text;
        if (className != null) element.className = className;
        if (id != null) element.id = id;
        element.extendDOM();
        this.appendChild(element);
        return element;
    }

    this.addH2 = function (text, className, id) {
        var element = document.createElement('h2');
        if (text != null) element.innerText = text;
        if (className != null) element.className = className;
        if (id != null) element.id = id;
        element.extendDOM();
        this.appendChild(element);
        return element;
    }

    this.addH3 = function (text, className, id) {
        var element = document.createElement('h3');
        if (text != null) element.innerText = text;
        if (className != null) element.className = className;
        if (id != null) element.id = id;
        element.extendDOM();
        this.appendChild(element);
        return element;
    }

    this.addH4 = function (text, className, id) {
        var element = document.createElement('h4');
        if (text != null) element.innerText = text;
        if (className != null) element.className = className;
        if (id != null) element.id = id;
        element.extendDOM();
        this.appendChild(element);
        return element;
    }

    this.addSpan = function (data) {
        if (data == null) data = {};
        var element = document.createElement('span');
        if (data.id != null) element.id = data.id;
        if (data.text != null) element.innerHTML = data.text;
        if (data.className != null) element.className = data.className;
        if (data.hidden == true) element.style.display = 'none';
        element.extendDOM();
        this.appendChild(element);
        return element;
    }

    this.addDiv = function (data, beforeElement) {
        if (data == null) data = {};
        var element = document.createElement('div');
        if (data.id != null) element.id = data.id;
        if (data.text != null) element.innerHTML = data.text;
        if (data.className != null) element.className = data.className;
        if (data.hidden == true) element.style.display = 'none';
        if (data.sid != null) element.setAttribute('sid-key', data.sid);
        element.extendDOM();
        if (!beforeElement) this.appendChild(element);
        else this.insertBefore(element, beforeElement);
        return element;
    }

    this.addLabel = function (targetId, title, className, labelId) {
        var element = document.createElement('label');
        if (labelId != null) element.id = labelId;
        element.setAttribute('for', targetId);
        element.innerHTML = title;
        if (className != null) element.className = className;
        element.extendDOM();
        this.appendChild(element);
        return element;
    }

    this.addButtonSpan = function () {
        return this.addSpan({ 'className': 'button-span' });
    }

    //#endregion

    //#region Data Change Managment

    this.addDataChanged = function (field) {
        this.addEventListener("change", (event) => { field.value = event.srcElement.value });
    }

    //#endregion

    //#region Input Elements

    this.addTextbox = function (id, maxChars, sidKey, requiredGroup, requiredMessage, className, validators, initialValue) {
        return this.addInput('text', id, maxChars, sidKey, requiredGroup, requiredMessage, clickEventHandler, className, true, validators, initialValue)
    }

    this.addPasswordbox = function (id, maxChars, sidKey, requiredGroup, requiredMessage, clickEventHandler, className, validators, initialValue) {
        return this.addInput('password', id, maxChars, sidKey, requiredGroup, requiredMessage, clickEventHandler, className, false, validators, initialValue)
    }

    this.addInput = function (inputType, id, maxChars, sidKey, requiredGroup, requiredMessage, clickEventHandler, className, autoComplete, validators, initialValue) {
        var element = document.createElement('input');
        element.id = id;
        element.type = inputType;
        if (!autoComplete) element.setAttribute('autocomplete', 'new-password');
        if (className != null) element.className = className;
        if (maxChars != null) element.maxLength = maxChars;
        if (sidKey != null) element.setAttribute('sid-key', sidKey);
        if (requiredGroup != null) element.setAttribute('requiredGroup', requiredGroup);
        if (requiredMessage != null) element.setAttribute('requiredErrorMessage', requiredMessage);// element.requiredErrorMessage = requiredMessage
        if (clickEventHandler != null) element.addEventListener('click', clickEventHandler);
        element.extendDOM();
        this.appendChild(element);
        if (validators != undefined) {
            for (const validator of validators) {
                switch (validator.validationType) {
                    case "Required":
                        if (initialValue != '') element.setAttribute(validator.validationType.toLowerCase(), validator.parameter);
                        continue;

                    default:
                        element.setAttribute(validator.validationType.toLowerCase(), validator.parameter);
                        break;
                }
            }
        }
        return element;
    }

    this.addRadioButton = function (id, buttonGroupName, value, sidKey, clickEventHandler, className) {
        var element = document.createElement('input');
        element.id = id;
        element.type = 'radio'
        element.name = buttonGroupName;
        element.value = value;
        if (className != null) element.className = className;
        if (sidKey != null) element.setAttribute('sid-key', sidKey);
        if (clickEventHandler != null) element.addEventListener('click', clickEventHandler);
        element.extendDOM();
        this.appendChild(element);
        return element;
    }

    this.addCheckbox = function (id, value, checked, sidKey, clickEventHandler, className) {

        var element = document.createElement('input');
        element.id = id;
        if (className != null) element.className = className;
        element.type = 'checkbox'
        element.checked = checked;
        element.value = value;
        if (sidKey != null) element.setAttribute('sid-key', sidKey);
        if (clickEventHandler != null) element.addEventListener('click', clickEventHandler);
        element.extendDOM();
        this.appendChild(element);
        return element;
    }

    //#endregion

    //#region Buttons

    this.addButton = function (id, text, clickEventHandler, hidden, className, sidKey) {
        var element = document.createElement('button');
        element.id = id;
        element.innerText = text;
        if (sidKey != null) element.setAttribute('sid-key', sidKey);
        if (className != null) element.className = className;
        if (hidden == true) element.style.display = 'none';
        if (clickEventHandler != null) element.addEventListener('click', clickEventHandler);
        element.extendDOM();
        this.appendChild(element);
        return element;
    }



    //#endregion

    //#region Componants

    this.addRadioButtonAndLabel = function (id, buttonGroupName, title, value, sidKey, clickEventHandler, className, spanData) {
        var element = this.addSpan(spanData);
        element.radioButton = element.addRadioButton(id, buttonGroupName, value, sidKey, clickEventHandler, className);
        element.label = element.addLabel(id, title);
        return element;
    }

    this.addPasswordAndLabel = function (id, maxChars, title, sidKey, requiredGroup, requiredMessage, clickEventHandler, className, spanData) {
        var element = this.addSpan(spanData);
        element.label = element.addLabel(id, title);
        element.input = element.addPasswordbox(id, maxChars, sidKey, requiredGroup, requiredMessage, clickEventHandler, className);
        return element;
    }

    this.addToggleSwitch = function (id, text, value, checked, sidKey, clickEventHandler, data) {

        if (data == null) data = {};
        if (data.className != undefined) data.className = 'switch-toggle ' + data.className
        else data.className = 'switch-toggle';
        var element = this.addSpan(data);
        element.checkbox = element.addCheckbox(id, value, checked, sidKey, clickEventHandler, data.cbClassName);
        element.fakeLabel = element.addLabel(id, null, data.label1ClassName, data.label1Id);
        element.label = element.addLabel(id, text, data.label2ClassName, data.label2Id);
        return element;
    }

    //#endregion

    //#region Textbox actions

    this.addButtonToClickById = function (btnId) {

        var input = this;
        var btn = document.getElementById(btnId);
        input.addButtonToClick(btn);

    }

    this.addButtonToClick = function (btn) {

        // Execute a function when the user presses a key on the keyboard
        var input = this;
        input.addEventListener("keypress", function (event) {
            // If the user presses the "Enter" key on the keyboard
            if (event.key === "Enter") {
                // Cancel the default action, if needed
                event.preventDefault();
                // Trigger the button element with a click
                btn.click();
            }
        });

    }

    this.addElementToTabToById = function (destElementId) {

        var srcElement = this;
        var destElement = document.getElementById(destElementId);
        srcElement.addElementToTabTo(destElement);

    }

    this.addElementToTabTo = function (destElement) {

        // Execute a function when the user presses a key on the keyboard
        var srcElement = this;
        srcElement.addEventListener("keypress", function (event) {
            // If the user presses the "Enter" key on the keyboard
            if (event.key === "Tab") {
                // Cancel the default action, if needed
                event.preventDefault();
                // Trigger the button element with a click
                destElement.focus();
            }
        });

    }



    //#endregion

    //#region Misc

    return this;

    //#endregion
}

